import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const FX_FALLBACK = 15500;

const FxContext = createContext({ rate: FX_FALLBACK, source: "fallback" });

export function FxProvider({ children }) {
  const [state, setState] = useState({ rate: FX_FALLBACK, source: "fallback" });

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const { data } = await axios.get(`${BACKEND_URL}/api/fx/usd-idr`, { timeout: 8000 });
        if (mounted && data?.rate) setState({ rate: data.rate, source: data.source });
      } catch (e) {
        // silently keep fallback
      }
    })();
    return () => {
      mounted = false;
    };
  }, []);

  const toUSD = (idr) => {
    const usd = idr / (state.rate || FX_FALLBACK);
    if (usd >= 100) return `$${Math.round(usd)}`;
    return `$${usd.toFixed(usd < 10 ? 2 : 1)}`;
  };

  return <FxContext.Provider value={{ ...state, toUSD }}>{children}</FxContext.Provider>;
}

export function useFx() {
  return useContext(FxContext);
}

export function formatIDR(n, lang = "en") {
  const locale = lang === "id" ? "id-ID" : "en-US";
  return "IDR " + new Intl.NumberFormat(locale).format(n);
}
